module.exports = __webpack_public_path__ + "img/07-326x184-scharf.f11dd0a9.jpg";